<template>
  <div style="height: 50px; padding-top: 10px; font-family: 黑体">
    <!--<el-form :label-position="labelPosition" style="font-size: 32px; margin-left: 30px; background-color: purple;" inline class="demo-table-expand">-->
    <el-row type="flex" justify="space-around" style="width: 80%; margin-left: 10%;" >
      <el-col :span="3" :offset="5" >
        <div class="numBox">
          <span class="numBox_Title" >设备总数：</span><br>
          <span class="numBox_Num">{{devNum}}</span>
          <!--<span class="numBox_Num">20</span>-->
          <span class="numBox_Unit">台</span>
        </div>
      </el-col>
      <el-col :span="3" >
        <div class="numBox">
          <span class="numBox_Title" >设备供电：</span><br>
          <span class="numBox_Num">{{CENum}}</span>
          <!--<span class="numBox_Num">7</span>-->
          <span class="numBox_Unit">台</span>
        </div>
      </el-col>
      <el-col :span="3" >
        <div class="numBox">
          <span class="numBox_Title" >设备开机：</span><br>
          <span class="numBox_Num">{{onNum}}</span>
          <!--<span class="numBox_Num">3</span>-->
          <span class="numBox_Unit">台</span>
        </div>
      </el-col>
      <el-col :span="3" >
        <div class="numBox">
          <span class="numBox_Title" >监测在线：</span><br>
          <span class="numBox_Num">{{onlineNum}}</span>
          <!--<span class="numBox_Num">18</span>-->
          <span class="numBox_Unit">台</span>
        </div>
      </el-col>
      <el-col :span="3" >
        <div class="numBox" @click="gotoAlarmRecord" style="cursor:pointer ">
          <span class="numBox_Title" >监测分贝：</span><br>
          <span class="numBox_Num">{{alarmNum}}</span>
          <!--<span class="numBox_Num">3</span>-->
          <span class="numBox_Unit">台</span>
        </div>
      </el-col>
      <el-col :span="4"></el-col>

    </el-row>
    <!--</el-form>-->

  </div>
</template>

<script>
export default {
  name: 'HomeHeader2',
  props: ['realMapShow','areaId' ],
  data(){
    return {
      labelPosition: "left",
      CENum: 0, // 市电供电数
      alarmNum: 0, // 告警数
      devNum: 0, // 设备总数
      onNum: 0, // 开机数
      onlineNum: 0, //在线数
      AreaDevScreen:{
        "version": 1,
        "method": "synthScreen.AreaDevScreen",
        "params": {
          "areaId":"0",
        },
        "token": "",
        "id": 0
      },
      interval:null // 轮询
    }
  },
  methods:{
    gotoAlarmRecord(){
      this.$router.push('/alarmManage');
    },
    getAreaDevScreen(){
      this.AreaDevScreen.token = this.$store.state.token;
      this.AreaDevScreen.params.areaId = this.areaId;
      console.log('获取设备状态百分比');
      console.log(this.AreaDevScreen);
      this.$axios.post(this.$newMainUrl, this.AreaDevScreen).then(res=> {
        console.log('获取设备状态百分比请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.CENum = res.data.result.CENumAll;
          this.alarmNum = res.data.result.alarmNumAll;
          this.devNum = res.data.result.devNumAll;
          this.onNum = res.data.result.onNumAll;
          if(res.data.result.hasOwnProperty('onlineNumAll')){
            this.onlineNum = res.data.result.onlineNumAll;
          }
          else{
            this.onlineNum = res.data.result.onlineAll;
          }
        }else{
          this.$message({
            type:'error',
            message:'获取设备状态百分比失败，' + res.data.error.message
          })
        }
      })
    },
    switchMap(){
      // console.log('switchMap');
      // this.realMapShow =  !this.realMapShow;
      // this.real =  true;
      // this.$emit('feedBack', this.realMapShow);

      this.$router.push('/map');
    },
    getSystemStatistics(){
      this.GetSystemStatistics.token = this.$store.state.token;
      for(let key in this.GetSystemStatistics.params){
        if(this.GetSystemStatistics.params[key] === ""){
          this.GetSystemStatistics.params[key] = null;
        }
      }
      console.log('获取表格数据请求');
      console.log(this.GetSystemStatistics);
      this.$axios.post(this.$newMainUrl, this.GetSystemStatistics).then(res=>{
        console.log('获取表格数据请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'获取表格数据成功'
          })
          this.SystemStatistics = res.data;
          this.drawAll();
        }else{
          this.$message({
            type:'error',
            message:'获取表格数据失败，' + res.data.error.message
          })
        }
      }).catch(error=>{
        this.$message({
          type:'error',
          message:error
        })
      })
    },

  },
  watch:{
    'areaID'(newValue, oldValue){
      this.getAreaDevScreen();
    }
  },
  mounted () {
    // this.getSystemStatistics();
    this.getAreaDevScreen();
    this.interval = setInterval(()=>{
      this.getAreaDevScreen();
    }, 3000);
  },
  destroyed(){
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
  .numBox{
    width: 110px; height: 60px; background-color: #142664; color: white; text-align: center; padding-top: 5px;
  }
  .numBox_Title{
    font-size: 16px;
  }
  .numBox_Num{
    font-size: 32px; color: #00fea8; text-decoration:underline #00fea8
  }
  .numBox_Unit{
    font-size: 16px; color: white; margin-left: 5px;
  }

</style>
<style>
  .topBlock{
    display: flex; flex-wrap: nowrap;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .topBlock span{
    display: inline-block;
    width: 90px;
    color: #99a9bf;
    margin-top: 3px;
    margin-right: -30px;
  }
  .el-col:nth-child(1) .topBlock{
    /*margin-left: 50px;*/
    /*background-color: yellow;*/
  }
  .el-col .topBlock{
    /*margin-left: 50px;*/
    /*background-color: yellow;*/
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>

